/**
 * Section Pattern 5 Accordion
 */

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section-pattern-5-block')
        .forEach(block => new SectionPattern5Accordion(block));
});

class SectionPattern5Accordion {

    constructor(block) {
        if (block.dataset.accordionInitialized) return;

        this.block = block;
        this.groups = [...block.querySelectorAll('.foxtrot-accordion-group')];

        this.openOnHover =
            block.dataset.openOnHover === 'true' &&
            window.matchMedia('(min-width: 769px)').matches;

        this.hoverDelay = 80;
        this.hoverTimer = null;

        this.init();

        block.dataset.accordionInitialized = 'true';
    }

    init() {

        this.groups.forEach(group => {

            if (this.openOnHover) {
                group.addEventListener('mouseenter', this.handleHover.bind(this), true);
            } else {
                group.addEventListener('click', this.handleClick.bind(this));
            }

        });

    }

    /**
     * CLICK MODE
     */
    handleClick(e) {

        const summary = e.target.closest('summary');
        if (!summary) return;

        const detail = summary.parentElement;
        const group = detail.parentElement;

        if (!group.matches('.foxtrot-accordion-group')) return;

        e.preventDefault();

        const detailsElements = group.querySelectorAll(':scope > details');
        const isClosing = detail.hasAttribute('open');

        if (!isClosing) {

            detailsElements.forEach(sibling => {
                if (sibling !== detail && sibling.hasAttribute('open')) {
                    this.animateClose(sibling);
                }
            });

            this.animateOpen(detail);

        } else {
            this.animateClose(detail);
        }

    }

    /**
     * HOVER MODE
     */
    handleHover(e) {

        const detail = e.target.closest('details');
        if (!detail) return;

        const group = detail.parentElement;
        if (!group.matches('.foxtrot-accordion-group')) return;

        clearTimeout(this.hoverTimer);

        this.hoverTimer = setTimeout(() => {

            const detailsElements = group.querySelectorAll(':scope > details');

            detailsElements.forEach(sibling => {
                if (sibling !== detail && sibling.hasAttribute('open')) {
                    this.animateClose(sibling);
                }
            });

            if (!detail.hasAttribute('open')) {
                this.animateOpen(detail);
            }

        }, this.hoverDelay);

    }

    /**
     * Animate opening
     */
    animateOpen(details) {

        if (details.dataset.animating) return;
        details.dataset.animating = 'true';

        details.setAttribute('open', '');

        const summary = details.querySelector('summary');
        if (!summary) return;

        const startHeight = summary.offsetHeight;
        const endHeight = details.scrollHeight;

        const animation = details.animate(
            [
                { height: `${startHeight}px` },
                { height: `${endHeight}px` }
            ],
            {
                duration: 300,
                easing: 'ease-out'
            }
        );

        animation.onfinish = () => {
            details.style.height = '';
            details.open = true;
            delete details.dataset.animating;
        };

    }

    /**
     * Animate closing
     */
    animateClose(details) {

        if (details.dataset.animating) return;
        details.dataset.animating = 'true';

        const summary = details.querySelector('summary');
        if (!summary) return;

        const startHeight = details.offsetHeight;
        const endHeight = summary.offsetHeight;

        const animation = details.animate(
            [
                { height: `${startHeight}px` },
                { height: `${endHeight}px` }
            ],
            {
                duration: 300,
                easing: 'ease-out'
            }
        );

        animation.onfinish = () => {
            details.removeAttribute('open');
            details.style.height = '';
            delete details.dataset.animating;
        };

    }

}